module.exports = __webpack_public_path__ + "img/vegetable-peppers-350x184.69532f6a.jpg";